import { render, staticRenderFns } from "./brandPlaceList.vue?vue&type=template&id=9875c588&scoped=true&"
import script from "./brandPlaceList.vue?vue&type=script&lang=js&"
export * from "./brandPlaceList.vue?vue&type=script&lang=js&"
import style0 from "./brandPlaceList.vue?vue&type=style&index=0&id=9875c588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9875c588",
  null
  
)

export default component.exports